import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col, Row } from 'react-bootstrap';
import { getEquipmentGroupList } from '../../../actions/eg-kanban';
import Column from './Column';

const Columns = (props) => {
    const { columns, draggableType, refresh, selectedPlanTypeId } = props;

    useEffect(() => {
        props.actions.getEquipmentGroupList({ farmId: props.farmId, crew: 1, device: 1, planTypeId: selectedPlanTypeId });
    }, [refresh]);

    const firstRowItems = columns.filter((e, i) => i < 4);
    const secondRowItems = columns.filter((e, i) => (i >= 4 && i < 8));

    return (<div className="kanban-column">
        <Row lg={12} md={12} sm={12} className="m-0 h-50 pb-1">
            {firstRowItems.map((e, i) => <Col key={i} lg={3} md={3} sm={3} className={`kanban-column-item`}>
                <Column egId={e.egId} columnId={e.columnId} draggableType={draggableType} />
            </Col>)}
        </Row>
        <Row lg={12} md={12} sm={12} className="m-0 h-50 pt-1">
            {secondRowItems.map((e, i) => <Col key={i} lg={3} md={3} sm={3} className={`kanban-column-item`}>
                <Column egId={e.egId} columnId={e.columnId} draggableType={draggableType} />
            </Col>)}
        </Row>
    </div>)
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getEquipmentGroupList
    }, dispatch)
});

const mapStateToProps = state => ({
    columns: state.egKanban.columns,
    refresh: state.egKanban.refresh,
    selectedPlanTypeId: state.plan.selectedPlanType
});

export default connect(mapStateToProps, mapDispatchToProps)(Columns);